import Tippy from '@tippyjs/react';
// import "tippy.js/dist/tippy.css";

function Tooltip({
  children,
  content,
  jsxContent = undefined,
  placement = 'top',
  disabled = false,
  className = '',
}) {
  if (((!content && !jsxContent) || disabled) && !invoiceMessageIds) {
    return children;
  }

  if (!jsxContent) {
    jsxContent = (
      <div
        className={className}
        dangerouslySetInnerHTML={{ __html: content }}
      ></div>
    );
  }

  return (
    <Tippy content={jsxContent} placement={placement}>
      {children}
    </Tippy>
  );
}

export default Tooltip;
